import { Stars02Icon } from '@langchain/untitled-ui-icons';
import { Modal, ModalClose, ModalDialog } from '@mui/joy';

import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Button, Text } from '@/design-system';

export function SuccessModal({
  isOpen,
  setOpen,
  title,
  description,
  customCta,
}: {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  description: ReactNode;
  customCta?: ReactNode;
}) {
  return (
    <Modal
      open={isOpen}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
      }}
    >
      <ModalDialog variant="outlined" sx={{ width: 550 }}>
        <ModalClose size="lg" />
        <div className="flex flex-col items-start gap-2">
          <div className="ml-1 flex h-[52px] w-[52px] items-center justify-center rounded-full bg-success-primary">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-success-primary text-success">
              <Stars02Icon className="h-6 w-6" />
            </div>
          </div>
          <div className="flex flex-col items-start gap-4 p-3">
            <Text variant="h2">{title}</Text>
            {description}
          </div>

          <div className="mr-3 mt-3 flex items-center gap-3 self-end">
            {customCta}
            <Link to="?tab=2">
              <Button onClick={() => setOpen(false)} size="md">
                Set usage limits
              </Button>
            </Link>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
}
